import { Stripe, StripeElements } from '@stripe/stripe-js';

/** Saves the card against the mounted SetupIntent and returns its payment method id. */
export const confirmCardSetup = async (
  stripe: Stripe,
  elements: StripeElements,
): Promise<{ ok: true; paymentMethodId: string } | { ok: false; error: string }> => {
  const { setupIntent, error } = await stripe.confirmSetup({
    elements,
    redirect: 'if_required',
    confirmParams: { return_url: window.location.href, expand: ['payment_method'] },
  });
  if (error) {
    return { ok: false, error: error.message ?? 'Could not save the card' };
  }
  const paymentMethodId =
    typeof setupIntent?.payment_method === 'string'
      ? setupIntent.payment_method
      : setupIntent?.payment_method?.id;
  return paymentMethodId
    ? { ok: true, paymentMethodId }
    : { ok: false, error: 'Could not validate your card' };
};
